module.exports = __webpack_public_path__ + "static/media/bankbal.02d503d6.svg";